
import { Navigate } from "react-router-dom";
import Auth from "@/pages/Auth";
import { RouteProps } from "@/types/routes";
import { RouteObject } from "react-router-dom";
import Onboarding from "@/pages/Onboarding";
import Terms from "@/pages/Terms";
import ChefTerms from "@/pages/ChefTerms";

export const authRoutes = ({ session }: RouteProps): RouteObject[] => {
  console.log("Auth routes initialized, session:", !!session);
  
  // Check for new user status from session storage
  const isNewUser = typeof window !== 'undefined' && sessionStorage.getItem('is_new_user') === 'true';
  console.log("Auth routes check - isNewUser:", isNewUser);
  
  return [
    {
      path: "/auth",
      element: !session ? <Auth /> : (isNewUser ? <Navigate to="/onboarding" /> : <Navigate to="/" />)
    },
    {
      path: "/onboarding",
      element: session ? <Onboarding /> : <Navigate to="/auth" />
    },
    {
      path: "/terms",
      element: <Terms />
    },
    {
      path: "/chef-terms",
      element: <ChefTerms />
    }
  ];
};
